import { notification } from 'antd';

const toaster = {
	show: (options: { message: string; type: 'error' | 'info' | 'success' | 'warning' }) => {
		notification.open(options);
	},
};

export default toaster;
